import { RefObject } from 'react';

// Returns the focusable suggestion rows inside the reference popover in DOM order; used for keyboard nav and Tab entry from the search input.
export const getPopoverItemRows = (
  listRef: RefObject<HTMLElement | null>
): HTMLElement[] =>
  Array.from(
    listRef.current?.querySelectorAll<HTMLElement>(
      'ion-item[tabindex="0"]'
    ) ?? []
  );
